import { Create } from 'react-admin';
import { ChangeUserForm } from '../../../../widgets/ChangeUserForm/ui/ChangeUserForm';

export const UserCreate = () => (
  <Create>
    <ChangeUserForm />
  </Create>
);
